/**
 * useCommunityImages Hook
 * Fetches community data including images and videos using React Query
 */

import type { CommunityDetail } from "../types"
import { useCommunity } from "./useCommunity"

export function useCommunityImages(communityId: string) {
  // Fetch the full community data which includes images and videos
  const { data, isLoading } = useCommunity(communityId)

  return {
    data: data as CommunityDetail | undefined,
    isLoading,
  }
}
